import React, { useState } from "react";
import { OPENING_PRESETS } from "../../constants";

export default function OpeningPopup({ edgeId, clickT, screenPt, onAdd, onClose }) {
  const [preset, setPreset] = useState("DOOR_STD");
  if (!edgeId) return null;

  return (
    <div style={{
      position: "absolute", left: screenPt.x, top: screenPt.y,
      background: "#09090f", border: "1px solid #fb923c40",
      borderRadius: 8, padding: "12px 14px", zIndex: 50, width: 215, boxShadow: "0 8px 32px #000c",
    }}>
      <div style={{ fontSize: 8, color: "#fb923c", letterSpacing: 2, marginBottom: 8, fontWeight: 800 }}>
        ADD OPENING
      </div>

      {Object.entries(OPENING_PRESETS).map(([k, p]) => (
        <button
          key={k}
          onClick={() => setPreset(k)}
          style={{
            display: "block", width: "100%", padding: "5px 8px", marginBottom: 3,
            borderRadius: 3, fontSize: 8.5, cursor: "pointer", textAlign: "left",
            background: preset === k ? "#1e2c18" : "#0c1320",
            border: preset === k ? "1px solid #4ade80" : "1px solid #131924",
            color: preset === k ? "#4ade80" : "#4a5e70",
          }}
        >
          {p.sillHeight > 0 ? "🪟" : "🚪"} {p.label}
        </button>
      ))}

      <div style={{ display: "flex", gap: 5, marginTop: 8 }}>
        <button
          onClick={() => onAdd(OPENING_PRESETS[preset], clickT)}
          style={{ flex: 1, padding: "6px", background: "#1c0c00", border: "1px solid #fb923c40", color: "#fb923c", borderRadius: 3, cursor: "pointer", fontSize: 9 }}
        >
          ⊕ Place
        </button>
        <button
          onClick={onClose}
          style={{ padding: "6px 8px", background: "transparent", border: "1px solid #131924", color: "#4a5e70", borderRadius: 3, cursor: "pointer", fontSize: 9 }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
